import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, TablePagination } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import { db } from "../../Environment/firebase";

export default function MStudyList() {
  const navigate = useNavigate();
  const [questions, setQuestions] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const snapshot = await db.collection("questions").orderBy("createdAt", "desc").get();
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setQuestions(data);
      } catch (error) {
        console.error("Error fetching questions: ", error);
      }
    };
    fetchQuestions();
  }, []);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Box sx={{ mt: 3, ml: 2, p: 2, maxWidth: 1000, margin: "auto", textAlign: "left", minHeight: "75vh" }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>M-Study 問題管理一覧</Typography>
        <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={() => navigate("/mypage/mstudy/new")}>
          新規作成
        </Button>
      </Box>

      <TableContainer component={Paper} variant="outlined">
        <Table>
          <TableHead sx={{ bgcolor: "#f5f5f5" }}>
            <TableRow>
              <TableCell sx={{ whiteSpace: "nowrap" }}>No.</TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>年齢</TableCell>
              <TableCell sx={{ whiteSpace: "nowrap" }}>性別</TableCell>
              <TableCell sx={{ minWidth: 250 }}>主訴・症状</TableCell>
              <TableCell>タグ</TableCell>
              <TableCell>診療科</TableCell>
              <TableCell sx={{ whiteSpace: "nowrap", textAlign: "center" }}>設問数</TableCell>
              <TableCell sx={{ whiteSpace: "nowrap", textAlign: "center" }}>ステータス</TableCell>
              <TableCell>作成日時</TableCell>
              <TableCell sx={{ whiteSpace: "nowrap", textAlign: "center" }}>アクション</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {questions.length === 0 && (
              <TableRow>
                <TableCell colSpan={10} align="center">登録された問題がありません</TableCell>
              </TableRow>
            )}
            {questions.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((q) => (
              <TableRow key={q.id}>
                <TableCell sx={{ whiteSpace: "nowrap" }}>
                  {q.questionNumber ? `No.${q.questionNumber}` : "-"}
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }}>
                  {q.caseInfo?.age ? (q.caseInfo.age < 10 ? "10歳未満" : q.caseInfo.age >= 100 ? "100歳以上" : `${Math.floor(q.caseInfo.age / 10) * 10}代`) : "年齢不明"}
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }}>
                  {q.caseInfo?.gender === "male" ? "男性" : q.caseInfo?.gender === "female" ? "女性" : "その他"}
                </TableCell>
                <TableCell>
                  <Typography variant="body2" sx={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                    {q.caseInfo?.history || "主訴・症状なし"}
                  </Typography>
                </TableCell>
                <TableCell>
                  {q.tags && q.tags.map((t: string, i: number) => (
                    <Chip key={i} label={t} size="small" sx={{ mr: 0.5, mb: 0.5 }} />
                  ))}
                </TableCell>
                <TableCell>
                  {q.departmentTags && q.departmentTags.map((t: string, i: number) => (
                    <Chip key={i} label={t} size="small" sx={{ mr: 0.5, mb: 0.5 }} />
                  ))}
                </TableCell>
                <TableCell align="center">
                  {q.quizItems?.length || 0}問
                </TableCell>
                <TableCell align="center">
                  <Chip 
                    label={q.status === "published" ? "公開中" : "下書き"} 
                    color={q.status === "published" ? "primary" : "default"} 
                    size="small" 
                  />
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }}>
                  {q.createdAt ? new Date(q.createdAt.toDate()).toLocaleDateString() : "未設定"}
                </TableCell>
                <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                  <Button 
                    variant="outlined" 
                    size="small"
                    startIcon={<EditIcon />}
                    sx={{ mr: 1 }}
                    onClick={() => navigate(`/mypage/mstudy/${q.id}/edit`)}
                  >
                    編集
                  </Button>
                  <Button 
                    variant="outlined" 
                    size="small" 
                    startIcon={<VisibilityIcon />}
                    onClick={() => window.open(`/mstudy/${q.id}`, "_blank")}
                  >
                    閲覧
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={questions.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="1ページあたりの表示数:"
        />
      </TableContainer>
    </Box>
  );
}